// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestedContentSidebar-cls1__db75edc9ef7571bbac12","cls2":"SuggestedContentSidebar-cls2__c67f734bef9427535d17 SuggestedContentSidebar-cls1__db75edc9ef7571bbac12"};